import { Swiper } from 'swiper';
import {Navigation} from "swiper/modules";
Swiper.use([Navigation]);

export default () => {
    const nodeSelectors = {
        container: '[js-slider="container"]',
        slider: '[js-slider="slider"]',
        prev: '[js-slider="prev"]',
        next: '[js-slider="next"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.slider)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        let slidersContainers = document.querySelectorAll(nodeSelectors.container)

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)

            let slider = new Swiper(sliderEl, {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                speed: 500,
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                }
            });
        })
    }

    return Object.freeze({
        init,
    })
}